import React, { useState } from 'react';
import { useAuth } from './Auth';
import { User } from './types';
import { api } from './utils/api';
import './styles/Accounts.css';

export default function AccountsPage(): JSX.Element {
  const { user } = useAuth();
  const [form, setForm] = useState<Partial<User>>({
    ID: '',
    Username: '',
    Password: '',
    UserType: 'viewer',
    Email: '',
  });
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!user || user.UserType !== 'admin') {
    return (
      <div className="accounts-root">
        <div className="accounts-card">
          <h2>Accounts</h2>
          <p>You must be an admin to view this page.</p>
        </div>
      </div>
    );
  }

  const update = (k: keyof User, v: any) => setForm((s) => ({ ...(s || {}), [k]: v }));


  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);

    // basic validation
    if (!form.Username || !form.Password || !form.Email) {
      setMessage('username, password and email are required');
      return;
    }


    const payload: any = {
      client: form.ID && form.ID.length > 0 ? form.ID : `${form.Username}-${Date.now()}`,
      username: form.Username || '',
      passwordHash: form.Password,
      userType: (form.UserType as any) || 'viewer',
      email: form.Email || '',
    };

    setSubmitting(true);
    try {
      const res = await api.get('/setUser', 'POST', JSON.stringify(payload));
      if (!res.ok) {
        const txt = await res.text();
        setMessage(`Failed: ${res.status} ${txt}`);
      } else {
        setMessage('User created/updated successfully');
        // clear form
        setForm({ ID: '', Username: '', Password: '', UserType: 'viewer', Email: '' });
      }
    } catch (err: any) {
      setMessage(`Error: ${err?.message || err}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="accounts-root">
      <div className="accounts-card">
        <h2>Create / Update User</h2>
        <form onSubmit={onSubmit} className="accounts-form">
          <label>
            ID (optional)
            <input value={form.ID || ''} onChange={(e) => update('ID', e.target.value)} placeholder="user-id (auto if left blank)" />
          </label>
          <label>
            Username
            <input value={form.Username || ''} onChange={(e) => update('Username', e.target.value)} placeholder="username" />
          </label>
          <label>
            Password
            <input value={form.Password} onChange={(e) => update('Password', e.target.value)} placeholder="password" type="password" />
          </label>
          <label>
            Email
            <input value={form.Email || ''} onChange={(e) => update('Email', e.target.value)} placeholder="email@example.com" type="email" />
          </label>
          <label>
            User Type
            <select value={form.UserType || 'viewer'} onChange={(e) => update('UserType', e.target.value as any)}>
              <option value="admin">admin</option>
              <option value="editor">editor</option>
              <option value="viewer">viewer</option>
            </select>
          </label>

          <div className="accounts-actions">
            <button type="submit" disabled={submitting}>{submitting ? 'Saving…' : 'Save User'}</button>
          </div>

          {message && <div className="accounts-message">{message}</div>}
        </form>
      </div>
    </div>
  );
}
